module.exports = __webpack_public_path__ + "static/img/plane.4004bde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plane.png
// module id = 1ZKA
// module chunks = 1